import { ConfirmationAction } from '@app/components/ConfirmationAction';
import { useToast } from '@app/core/notifications';
import { streamerBoxStreamerBoxDevicesReboot } from '@mi-front/api-v2';
import { Device } from '@mi-front/core';
import { useAsyncViewCtx } from '@mi-front/ui';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

interface PropsP {
  readonly device: Device;
  readonly restart: () => Promise<void>;
}

/** Confirmation UI to reboot a stream-box device. */
export function DeviceRestartP(p: PropsP) {
  const { $t } = useIntl();
  const { notifyInfo } = useToast();

  return (
    <ConfirmationAction
      message={$t({
        id: 'streamBox.viewScreen.actions.reboot.confirm',
        defaultMessage: '¿Desea realmente reiniciar el dispositivo?',
      })}
      onConfirm={async () => {
        await p.restart();
        notifyInfo(
          $t({
            id: 'streamBox.viewScreen.actions.reboot.done',
            defaultMessage: 'Solicitud de reinicio enviada',
          }),
        );
      }}
    >
      {({ onClick }) => (
        <Button size="small" onClick={onClick} startIcon={<RestartAltIcon />}>
          <FormattedMessage
            id="streamBox.viewScreen.actions.reboot.btn"
            defaultMessage="Reiniciar"
          />
        </Button>
      )}
    </ConfirmationAction>
  );
}

/** Reboots a stream-box device and reloads the parent AsyncView. */
export function DeviceRestart(p: { device: Device }) {
  const { reload } = useAsyncViewCtx();

  return (
    <DeviceRestartP
      device={p.device}
      restart={async () => {
        await streamerBoxStreamerBoxDevicesReboot(String(p.device.id));
        reload();
      }}
    />
  );
}
